import React from 'react';
import { m } from 'framer-motion';
import { SectionTag } from '../ui/SectionTag';
export function TaglineCta() {
  return <section className="bg-primary py-10 sm:py-14" data-id="element-194" data-mp="yflgtzsrrpb0">
      <m.div initial={{
      opacity: 0,
      y: 14
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.45
    }} className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-195" data-mp="12gnhml2c49f3">
        <SectionTag icon="🏆" tone="gold" data-id="element-196" data-mp="1cds5cpbtwcy0">
          La biblioteca N.º 1 práctica para preparar tus clases
        </SectionTag>
        <h2 className="mt-5 font-heading text-2xl font-bold leading-tight text-white sm:text-3xl" data-id="element-197" data-mp="1hbjy1lkas339">
          Enciclopedia Pilates 360 — Colección Completa
        </h2>
        <p className="mt-3 text-base leading-relaxed text-white/80 sm:text-lg" data-id="element-198" data-mp="1q4ol3fknoznn">
          6 Tomos + 6 Bonos Premium — con opciones para simplificar y progresar según el control
          observado, en suelo, Reformer, Cadillac, Silla, accesorios y pared.
        </p>
      </m.div>
    </section>;
}